export enum ESocketEvent {
  Events = 'events',
  Sse = 'sse',
}
